import React from 'react';
import { HeroVariant13 } from '../components/HeroVariant13';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage13() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1477">
      <Navigation data-id="element-1478" />
      <main data-id="element-1479">
        <HeroVariant13 data-id="element-1480" />
        <WhyUs data-id="element-1481" />
        <Services data-id="element-1482" />
        <FAQ data-id="element-1483" />
        <Testimonials data-id="element-1484" />
        <Consultation data-id="element-1485" />
      </main>
      <Footer data-id="element-1486" />
      <CookieBanner data-id="element-1487" />
      <FloatingContact data-id="element-1488" />
    </div>;
}